import request from '../utils/request';

  /**获取消息群发列表数据 */
  export function getMsgGroupSendListApi(params,authorization){
    return request({
      url: '/api/groupMsgSend/getMsgGroupSendList',
      method: 'post',
      data: params,
      headers: {
        "authorization": authorization
      }
    },true)
  }
// 获取 群发执行情况
export function executeInfoApi(params,Authorization) {
  return request({
    url: '/api/groupMsgSend/executeInfo',
    method: 'post',
    data:params,
    headers: {
      "authorization": Authorization
    }
  },true)
}
// 获取 执行情况统计
export function executeStaticApi(params,Authorization) {
  return request({
    url: '/api/groupMsgSend/executeStatic',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },true)
}
// 客户跟进-群sop-详情
export function msgGroupDetailApi(params,Authorization) {
  return request({
    url: '/api/groupMsgSend/msgGroupDetail',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },true)
}
// 删除群发数据
export function removeSendMsgApi(params,Authorization) {
  return request({
    url: '/api/groupMsgSend/removeSendMsg',
    method: 'delete',
    params,
    headers: {
      "authorization": Authorization
    }
  },true)
}
// 客户跟进-群sop-创建群sop  保存
export function createMsgSendApi(params,Authorization) {
  return request({
    url: '/api/groupMsgSend/createMsgSend',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  },true)
}
// 客户跟进-群sop-编辑  保存
export function msgGroupSaveApi(params,Authorization) {
  return request({
    url: '/api/groupMsgSend/msgGroup',
    method: 'put',
    data: params,
    headers: {
      "authorization": Authorization
    }
  },true)
}
// 再次提醒标记 true 表示可以再次推送 false 表示已达到上线
export function getRemindTimeFlagApi(params,Authorization) {
  return request({
    url: '/api/groupMsgSend/getRemindTimeFlag',
    method: 'get',
    params: params,
    headers: {
      "authorization": Authorization
    }
  },true)
}
// 一键再次提醒
export function remindAgainApi(params,Authorization) {
  return request({
    url: '/api/groupMsgSend/remindAgain',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },true)
}
